import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import {profileActions, questionnaireActions} from "_actions";
import * as _ from 'lodash';
import { history } from '_helpers/history'
import {Space, Button, Modal, Radio, Checkbox, Tooltip} from 'antd';
import "../../startCeiba.scss";
import "../../noGamificado.scss";
import item1 from "../../../../../assets/img/items/item1.png";
import {InfoCircleOutlined, LeftOutlined} from "@ant-design/icons";
import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "../../../../../_helpers/localOrSessionStore";
import variables from "../../../../../_constants/variables";
import SliderV from "../../../../../components/Slider/SliderV";
import {useLocation} from "react-router-dom";

function StartNogam3Page(props) {

    const dispatch = useDispatch();
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const { t} = useTranslation();
    const [init, setInit] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const location = useLocation();
    const [restartQuestions, setRestartQuestions] =  useState(new URLSearchParams(location.search).get('restart') === 'true');
    const [touch, setTouch] = useState(false);
    const [step, setStep] = useState(localStorage.getItem(variables.LASTNOGAM5) ? +localStorage.getItem(variables.LASTNOGAM5) : -1);

    const [, setSubStep] = useState(-1);
    const [data, setData] = useState(null);
    const [assessment, setAssessment] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [value, setValue] = useState(null)
    const [showModal, setShowModal] = useState(false);
    const [valueOb, setValueOb] = useState(null);

    function onChange(value) {
        setDisabled(false);
        setTouch(true)
        setValue(value)
    }

    var getItemsData = useSelector((state) => state.profileReducer.getItemsData);



    var assestmentsCodeData = useSelector((state) => state.questionnaireReducer.assestmentsCodeData);
    var assestmentsCodeDataError = useSelector((state) => state.questionnaireReducer.assestmentsCodeDataError);

    var saveAnswer = useSelector((state) => state.questionnaireReducer.saveAnswer);
    var saveAnswerError = useSelector((state) => state.questionnaireReducer.saveAnswerError);

    var answersData = useSelector((state) => state.questionnaireReducer.answersData);
    var answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);

    var responsesData = useSelector((state) => state.questionnaireReducer.responsesData);
    var studentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);

    useEffect(() => {
        if (answersDataError){

        }
        if (answersData){

            setAnswers(answersData);
            if (data && data.length) {
                if (answersData.length === data.length && !restartQuestions) {
                    localStorage.removeItem(variables.LASTNOGAM5);
                    history.push("/admin/end-nogam5")
                }else{
                    if (step+1 === (data.length)){
                        localStorage.removeItem(variables.LASTNOGAM5);
                        setDisabled(true);
                        setTouch(false);
                        setValue(null)
                        setAssessment(data[0])
                        setStep(0);
                        setSubStep(1);
                        setValueOb(null);
                    }else{
                        setDisabled(true);
                        setTouch(false);
                        setValue(null)
                        setAssessment(data[step + 1])
                        setStep(step + 1);
                        setSubStep(1);
                        setValueOb(null);
                    }
                }
            }
        }
    },[answersData,answersDataError])

    useEffect(() => {
        if(["SINGLE","MULTIPLE"].includes(assessment?.questionType)) dispatch(questionnaireActions.getResponses(assessment.id))
    }, [assessment]);

    const goBack = () => {

        if (step === 0){
            setStep(-1)
            setInit(true);
           // history.push("/admin/nogam5")
        }else{
            setDisabled(true);
            setTouch(false);
            setValue(null)
            setAssessment(data[step - 1])
            setStep(step - 1);
            setSubStep(1);
            setValueOb(null);
        }
    }

    useEffect(() => {
        dispatch(questionnaireActions.getAssessmentsCode("NOGAM5"))
        dispatch(questionnaireActions.getAnswers("NOGAM5"))
        dispatch(questionnaireActions.getArea())
        dispatch(profileActions.getItems())
    }, []);


    useEffect(() => {
        if (assestmentsCodeData){

            setAssessment(assestmentsCodeData[0])
            setData(assestmentsCodeData);

            if (localStorage.getItem(variables.LASTNOGAM5) && +localStorage.getItem(variables.LASTNOGAM5) !== -1) {

                setStep(+localStorage.getItem(variables.LASTNOGAM5));
                setSubStep(1);
            } else {
                setSubStep(1);
                setStep(-1);
            }
        }
    }, [assestmentsCodeData]);

    const Continue = () => {
        setShowModal(false)
        dispatch(questionnaireActions.getAnswers("NOGAM5"))
    }

    useEffect( () => {
        let mNext = true;
        if (saveAnswer){
            if (assessment.item){
                let mSave = true;
                if (getItemsData){
                    let mData = getItemsData.filter(item => item.item.id === assessment.item.id);
                    if (mData && mData.length > 0) mSave = false
                }
                
                if (mSave) {
                    dispatch(profileActions.saveItem({item: assessment.item.id}))
                    setShowModal(true);
                    mNext = false;
                }
            }
            const newList = answers.map(ans => {
                if(ans.assessment_id === assessment.id) {
                    return {...ans, points: value};
                }
                return {...ans};
            });
            let mKk = _.find(answers, { assessment_id: assessment.id });
            if (mKk)
                mKk.points = value
            setAnswers(newList);



            if (mNext)   dispatch(questionnaireActions.getAnswers("NOGAM5"))
        }
    },[saveAnswer])

    useEffect(() => {
        if (step !== -1){
            let mValue = _.filter(answers, function(o) { return o.assessment_id === assessment.id; });

            if (mValue && mValue[0]){

                setValue(mValue[0].points ?? -1);
               if (mValue[0].points){
                   setTouch(true)
               }else{
                   setTouch(false)
               }
                setValueOb(mValue[0].yesno ? mValue[0].yesno === 3 ? false :  mValue[0].yesno : null);
               if (mValue[0].yesno){
                   setTouch(true)
               }
                setDisabled(false)
            }
        }
    },[step])

    const saveResponse = () => {
    if (touch || (valueOb === 0)) {
        dispatch(questionnaireActions.saveAnswer({
            yesno: valueOb,
            points: valueOb === 0 ? 0 : value,
            assessment_id: assessment.id
        }))
        setTouch(false);
    }
    if(step===data.length-1) setRestartQuestions(null);
    }

    const start = () => {
        setInit(false);
        if (localStorage.getItem(variables.LASTNOGAM5) && +localStorage.getItem(variables.LASTNOGAM5) !== -1) {
            setAssessment(data[localStorage.getItem(variables.LASTNOGAM5)])
            setStep(+localStorage.getItem(variables.LASTNOGAM5));
        } else {
            setAssessment(data[0])
            setStep(0);
        }
        setValueOb(null);
    }

    const onChangeRadio = (e) => {

        setValueOb(e.target.value);

        if (!e.target.value) {
            setDisabled(false);
            setTouch(true)
        }
  if (e.target.value && value < 1) {
            setDisabled(true);

        }else {
            setDisabled(false);
        }
    };

    const saveAndContinue = () => {
        localStorage.setItem(variables.LASTNOGAM5, step -1);
        history.push("/admin/assessment")
    }

    const copyNoGam = () => <p className={"tooltip-text"} dangerouslySetInnerHTML={{__html: t('nogam5.copy')}}></p>

    return (
        <div className={"backGroundCeiba"}>
            <Modal className={"modalName modal-question modal-question--xs"} title={t("ceiba.elemento")} visible={showModal} onOk={Continue} onCancel={Continue}>
                <div className={"diNombre"}>
                    <div className={"titleInfo"}>{t("ceiba.conseguidoagua", {nombre: user.name})}</div>

                    <div className={"elemento"}>
                        <img src={item1} />
                    </div>

                        <Button style={{marginTop: 20}}  type={"primary"} onClick={() => Continue()}
                                className="primaryButton buttonSizeO center-text">{t("continuar")}</Button>

                </div>
            </Modal>
            <div className={"wrapper-question boxed"}>
                <div className={"insideCeiba boxed"}>
                    <Headerbutton saveAndContinue={saveAndContinue} title={t("nogam5.header")}/>
                </div>
                {init &&
                    <>

                        <div className={"container-pre-question boxed"} >
                            <div className={"content-pre-question"}>
                                <div className={"content-text-scroll"}>
                                    <p className={"pre-question-title"}>
                                        {t("nogam5.title")}&nbsp;
                                        <Tooltip
                                          overlayStyle={{maxWidth: 500}}
                                          title={copyNoGam}
                                        >
                                            <InfoCircleOutlined />
                                        </Tooltip>
                                    </p>
                                    <p className={"pre-question-list"}>{t('nogam5.desc1')} </p>
                                    <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('nogam5.desc2')}} />
                                    <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('nogam5.step1')}}/>
                                    <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('nogam5.step2')}}/>
                                    <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('nogam5.step3')}}/>
                                    <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('nogam5.step4')}}/>
                                    <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('nogam5.gracias')}} />
                                </div>
                                <Button type={"primary"} onClick={() => start()}
                                        className="primaryButton btn-start">{t("start")}</Button>
                            </div>
                            <Button type="link"
                                    icon={<LeftOutlined />}
                                    onClick={() => history.push("/admin/assessment")}
                                    className={"btn-back"}

                            >
                                {t("atras")}
                            </Button>
                        </div>
                        <div className={"footerTek"}>
                            <p dangerouslySetInnerHTML={{__html: t('nogam5.copy')}} />
                        </div>

                    </>

                }
                {step !== -1 && !init &&
                    <>

                        <div className={"container-question no-gamificado"} >
                            <div className={"container-question__auto-margin"}>
                                <div className={"question__header"}>
                                    <h2>{t("nogam5.title")} </h2>
                                    <span className={"count"}>{+step+1}/{data.length}</span>
                                </div>
                                <div className={"question__content"}>
                                    <div className={"question__content-mid"}>
                                        <div className={"question__content-mid__info"}>
                                            <div className={"question__content-mid__info-l"}>
                                                <div className={"container-line"}>
                                                    <p className={"container-line__text"} dangerouslySetInnerHTML={{__html: t('nogam5.info')}}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"question__content-mid__question"}>
                                            <p><strong>{assessment.question.replace('{{vocArea}}',studentArea?.area?.name??'')}</strong></p>


                                            {assessment.questionType === "RATING" &&
                                              <>
                                                  <SliderV
                                                    dots={true}
                                                    style={{marginTop: 20}}
                                                    step={1}
                                                    value={value}
                                                    onChange={onChange}
                                                    min={1}
                                                    max={10}
                                                  />
                                              </>

                                            }
                                            {assessment.questionType === "RATINGOB" &&
                                              <>
                                                  <Radio.Group onChange={onChangeRadio} value={valueOb}>
                                                      <Space direction="vertical">
                                                          <Radio value={1}>{t("yes")}</Radio>
                                                          <Radio value={0}>{t("no")}</Radio>
                                                      </Space>
                                                  </Radio.Group>
                                                  {valueOb === 1 &&
                                                    <>
                                                        <div className={"container-rattion"}>
                                                            <p><strong>Mi satisfacción con esta actividad ha sido</strong></p>
                                                            <SliderV
                                                              dots={true}
                                                              style={{marginTop: 20}}
                                                              step={1}
                                                              value={value}
                                                              onChange={onChange}
                                                              min={1}
                                                              max={10}/>
                                                        </div>
                                                    </>
                                                  }

                                              </>
                                            }

                                            {assessment.questionType === "RATING" || valueOb === 1  &&
                                              <>
                                                  <div className={"content-placeholderrating"}>
                                                      <p className="placeholderrating">
                                                          {valueOb === 1 ? t("muybaja") : t("desacuerdo") }</p>
                                                      <p className="placeholderrating">{valueOb === 1 ? t("muyalta") : t("deacuerdo") }</p>

                                                  </div>
                                              </>
                                            }

                                            {assessment.questionType === "RATING" && !valueOb  &&
                                              <>
                                                  <div className={"content-placeholderrating"}>
                                                      <p className="placeholderrating">{t("desacuerdo")}</p>
                                                      <p className="placeholderrating">{t("deacuerdo")}</p>
                                                  </div>
                                              </>
                                            }

                                            {assessment.questionType === "MULTIPLE" && !valueOb  && responsesData &&
                                              <Checkbox.Group onChange={onChange} options={responsesData
                                                  .map(response=>{
                                                      return {
                                                          label:response.question,
                                                          value:response.id
                                                      }})}>
                                              </Checkbox.Group>
                                            }

                                            {assessment.questionType === "SINGLE" && !valueOb  && responsesData &&
                                              <Radio.Group
                                                  onChange={(value)=>onChange(value.target.value)}
                                                  value={value}
                                                  options={responsesData
                                                  .map(response=>{
                                                      return {
                                                          label:response.question,
                                                          value:response.id
                                                      }})}>
                                              </Radio.Group>
                                            }
                                        </div>
                                    </div>
                                    <div className={"question__content-bottom"}>
                                        <div className="left">
                                           
                                              <Button onClick={() => goBack()}
                                                      type={"link"}
                                                      className="btnPrimaryWhite"
                                              >
                                                  {t("atras")}
                                              </Button>
                                            
                                        </div>
                                        <div className="right">
                                            <Button onClick={() => saveResponse()}
                                                    disabled={disabled}
                                                    type={"primary"}
                                                    className="primaryButton"
                                            >
                                                {t("continuar")}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                </>
            }
            </div>

        </div>
    )
}
export default withTranslation()(StartNogam3Page);
